<template lang="pug">
div(:class="currentView == 'chart' ? '': 'chartWrapper'")
    Button.cardBtn.textBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'textBtn'&&withRawBtn") {{ toggleViewHint }}
    Button.iconBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'iconBtn'&&withRawBtn" :icon="toggleViewHint") 
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                pie-chart(
                    style="height: 90%"
                    v-if="chartData.datacollection.labels.length > 0"
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
                EmptyPie(
                    v-else
                    style="height: 90%"
                    :chartTitle="chartTitle"
                    :chartWidth="chartWidth"
                    :chartHeight="chartHeight"
                    :titleDisplay="false")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData")
    template(v-else)
        template(v-if="currentView == 'chart'")
            pie-chart(
                style="height: 90%"
                v-if="chartData.datacollection.labels.length > 0"
                :chart-data="chartData.datacollection"
                :options="chartData.options"
                :width="chartWidth"
                :height="chartHeight")
            EmptyPie(
                style="height: 90%"
                v-else
                :chartTitle="chartTitle"
                :chartWidth="chartWidth"
                :chartHeight="chartHeight"
                :useGuage="true"
                :titleDisplay="false"
                :legendDisplay="false")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData" :no-data-text="$t('main.tableNoDataText')")
    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";
import { getEdgeChartData } from "@/api/monitor.js";
import PieChart from "@/components/pieChart.js";
import numeral from "numeral";
import EmptyPie from "@/components/dashboard/EmptyPie";

export default {
    name: "PieChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "chartTitle" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0.00a" },
        topNSize: { type: Number, default: 5 },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        useGuage: { type: Boolean, default: false },
        pieBackgroundColors: {
            type: Array,
            default: () => [["#55b5db", "#a074c4", "#e6cd69", "#d6d6d6", "#55dbbe", "#Cd3f45", "#db7b55"]]
        },
        legendDisplay: { type: Boolean, default: true },
        legendPosition: { type: String, default: "top" },
        legendAlign: { type: String, default: "center" },

        // 放置百分比在圖表中間, 這個位置需要再調整
        withPercentageText: { type: Boolean, default: false },

        isGetDataFromStore: { type: Boolean, default: false }
    },
    components: { PieChart, EmptyPie },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: { labels: [] },
                options: {}
            },
            nginxData: null,
            percentageText: "",
            rawDataTableColumns: [],
            rawDataTableData: [],
            currentView: "chart"
        };
    },
    methods: {
        fillChartData(nginxData) {
            var self = this;

            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    data: dataset.data,
                    backgroundColor: this.pieBackgroundColors[index]
                };
            });

            // 只有兩個數值的時候才會算百分比
            if (this.withPercentageText && datasets[0].data.length == 2) {
                // 百分比為第一項除總數
                // console.log(datasets[0].data[0]);
                // console.log(datasets[0].data[1]);
                // console.log(datasets[0].data[0] + datasets[0].data[1]);
                let percentage = (datasets[0].data[0] / (datasets[0].data[0] + datasets[0].data[1])) * 100;
                this.percentageText = percentage.toFixed(2) + "%";
            }

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets
                },
                options: {
                    elements: {
                        arc: {
                            borderWidth: 0
                        },
                        center: {
                            text: this.percentageText
                        }
                    },
                    scales: {
                        yAxes: [],
                        xAxes: []
                    },
                    legend: {
                        display: this.legendDisplay,
                        position: this.legendPosition,
                        onClick: (event, legendElement) => {
                            this.$emit("onLegendClick", legendElement.text);
                            // console.log("CLICK LEGEND");
                            // console.log(legendElement.text);
                        },
                        align: this.legendAlign
                    },
                    tooltips: {
                        enabled: true,
                        mode: "single",
                        callbacks: {
                            label: function(tooltipItems, data) {
                                // console.log(data);
                                // let index = tooltipItems.index;
                                // return `${data.labels[index]}: ${numeral(data.datasets[0].data[index]).format(
                                //     self.numeralFormat
                                // )}`;

                                let index = tooltipItems.index;
                                let currentLabel = data.labels[index];
                                let currentData = data.datasets[0].data[index];

                                // 計算百分比
                                let sum = 0;
                                for (let i = 0; i < data.datasets[0].data.length; i++) {
                                    sum += data.datasets[0].data[i];
                                }
                                let percentage = ((currentData / sum) * 100).toFixed(2);
                                return `${currentLabel}: ${percentage} %`;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    height: 200,
                    cutoutPercentage: 75,
                    rotation: this.useGuage ? 1 * Math.PI : 0.5 * Math.PI,
                    circumference: this.useGuage ? 1 * Math.PI : 2 * Math.PI,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle
                    }
                }
            };

            this.chartData = chartData;
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.rawDataTableColumns = [
                    {
                        title: this.$i18n.t(this.chartTitle),
                        key: "title"
                    },
                    {
                        title: "Value",
                        key: "value"
                    }
                ];
                let dataCollection = this.chartData.datacollection;
                this.rawDataTableData = dataCollection.labels.map((label, i) => {
                    return {
                        title: label,
                        value: numeral(dataCollection.datasets[0].data[i]).format(this.numeralFormat)
                    };
                });
            } else {
                this.currentView = "chart";
            }
        }
    },
    mounted() {},
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        }
    }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/PieChartWrapperV2.vue